<template>
  <div class="account-view">
    <div class="account-view__content">
      <div class="account-view__section">
        <div class="mb-4 p-2 login-form">
          <h1 class="title is-3 has-text-grey">{{ $t('login.headline') }}</h1>
        </div>
      </div>

      <div class="account-view__section has-background-grey-lighter">
        <div class="container login-form">
          <div class="columns is-multiline is-centered">
            <form @submit.prevent="login">
              <div class="column is-full" v-if="loginFailed">
                <p class="has-text-danger">
                  {{ $t('login.messages.loginFailed') }}
                </p>
              </div>
              <div class="column is-full">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3"> {{ $t('login.inputLabels.userNameOrEmail') }}</label>
                  <div class="control">
                    <input v-model="userName" class="input" type="text"
                           :placeholder="$t('login.inputLabels.userNameOrEmail')">
                  </div>
                </div>
              </div>
              <div class="column is-full">
                <div class="field">
                  <label class="label is-uppercase mt-3 ml-3">{{ $t('login.inputLabels.password') }}</label>
                  <div class="control">
                    <input v-model="password" class="input" type="password"
                           :placeholder="$t('login.inputLabels.password')">
                  </div>
                </div>
              </div>
              <div class="column is-full login-form__actions">
                <RouterLink to="/register" class="link link-primary">
                  {{ $t('login.mainActions.register') }}
                </RouterLink>
                <RouterLink to="/reset-password" class="link link-primary">
                  {{ $t('login.mainActions.forgotPassword') }}
                </RouterLink>

                <button
                    type="submit"
                    :disabled="userName.trim() === '' || password.trim() === ''"
                    :class="{'is-loading': processing}"
                    class="button is-primary-dark px-6"> {{ $t('login.mainActions.login') }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Login",
  data() {
    return {
      userName: "",
      password: "",
      processing: false,
      loginFailed: false
    }
  },
  computed: {
    ...mapGetters(['isUserLoggedIn']),
  },
  methods: {
    login() {
      this.processing = true;
      this.loginFailed = false;
      let vm = this;

      this.$store.dispatch('loginUser', {
        credentials: {
          username: this.userName,
          password: this.password
        }
      }).then(() => {
        this.loginFailed = false;
        if (Object.entries(this.$store.getters.allCartItems).length > 0) {
          this.$router.push('/payment-details')
        } else {
          this.$router.push("/account");
        }

      }).catch(() => {
        console.log('Catch login');
        this.loginFailed = true;
        this.processing = false;
      });
    },
    fetchCMSData() {
      this.$store.dispatch('fetchCMSPage', {urlSlug: "/"});
    },
  },
  created() {
    this.fetchCMSData();
    if (this.isUserLoggedIn) {
      this.$router.push("/account");
    }
  }
}
</script>

<style scoped>

</style>